import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { routing, appRoutingProviders, CanLoadDashboardSection } from './shared/router.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FacultyService } from './providers/faculty.service';
import { StatsService } from './providers/stats.service';
import { FacultyFellowshipSpecialisationService } from './providers/faculty_fellowship_specialisation.service';
import { MedicalProcedureService } from './providers/medical_procedure.service';
import { FacultyMedicalProcedureService } from './providers/faculty_medical_procedure.service';
import { FacultyMedicalProcedureCaseReviewParameterService } from './providers/faculty_medical_procedure_case_review_parameter.service';
import { HospitalService } from './providers/hospital.service';
import { FacultyMedicalProcedureParameterService } from './providers/faculty_medical_procedure_parameter.service';
import { ContinuousAssessmentService } from './providers/continuous_assessment.service';
import { RotationsService } from './providers/rotations.service';
import { ContinuingProfessionalDevelopmentService } from './providers/cpd.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ErrorDialogComponent } from './dialogs/error-dialog/error-dialog.component';
import { PromptDialogComponent } from './dialogs/prompt-dialog/prompt-dialog.component';
import { SuccessDialogComponent } from './dialogs/success-dialog/success-dialog.component';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { HelpTopicService } from './providers/help_topic.service';
import { EditDialogComponent } from './dialogs/edit-dialog/edit-dialog.component';
import { HospitalEditDialogComponent } from './dialogs/hospital-edit-dialog/hospital-edit-dialog.component';
import { SuggestedTrainersEditDialogComponent } from './dialogs/suggested-trainers-edit-dialog/suggested-trainers-edit-dialog.component';
import { TrainerPasswordEditDailogComponent } from './dialogs/trainer-password-edit-dailog/trainer-password-edit-dailog.component';
import { UsersPasswordResetDialogComponent } from './dialogs/users-password-reset-dialog/users-password-reset-dialog.component';
import { TraineePasswordResetDialogComponent } from './dialogs/trainee-password-reset-dialog/trainee-password-reset-dialog.component';
import { FellowshipProceduresEditDialogComponent } from './dialogs/fellowship-procedures-edit-dialog/fellowship-procedures-edit-dialog.component';
import { ParameterEditDialogComponent } from './pages/faculty-medical-procedure-parameter/parameter-edit-dialog/parameter-edit-dialog.component';
import { TrainersEditDialogComponent } from './dialogs/trainers-edit-dialog/trainers-edit-dialog.component';
import { UsersEditDialogComponent } from './dialogs/users-edit-dialog/users-edit-dialog.component';
import { TraineesEditDialogComponent } from './dialogs/trainees-edit-dialog/trainees-edit-dialog.component';
import { FellowshipSpecialisationEditDialogComponent } from './pages/faculty-fellowship-specialisation/fellowship-specialisation-edit-dialog/fellowship-specialisation-edit-dialog.component';
import { FellowshipCatEditDialogComponent } from './pages/faculty-medical-procedure-category/fellowship-cat-edit-dialog/fellowship-cat-edit-dialog.component';

import { FacultiesAddDialogComponent } from './dialogs/faculties-add-dialog/faculties-add-dialog.component';
import { HospitalAddDialogComponent } from './dialogs/hospital-add-dialog/hospital-add-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { TrainersAddDialogComponent } from './dialogs/trainers-add-dialog/trainers-add-dialog.component';
import { UserAddDialogComponent } from './dialogs/user-add-dialog/user-add-dialog.component';
import { TraineeAddDialogComponent } from './dialogs/trainee-add-dialog/trainee-add-dialog.component';
import { ProcedureHospitalAddDialogComponent } from './dialogs/procedure-hospital-add-dialog/procedure-hospital-add-dialog.component';
import { ProcedureParameterAddDialogComponent } from './dialogs/procedure-parameter-add-dialog/procedure-parameter-add-dialog.component';
import { ProcedureReviewParameterAddDialogComponent } from './dialogs/procedure-review-parameter-add-dialog/procedure-review-parameter-add-dialog.component';

import { SuccessSnackbarComponent } from './dialogs/success-snackbar/success-snackbar.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { AcademicYearService } from './providers/academy_year.service';
import { EmergencyFellowshipProAddDialogComponent } from './dialogs/emergency-fellowship-pro-add-dialog/emergency-fellowship-pro-add-dialog.component';
import { EmergencyMembershipAddDialogComponent } from './dialogs/emergency-membership-add-dialog/emergency-membership-add-dialog.component';
import { FellowshipSpecialisationAddDialogComponent } from './pages/faculty-fellowship-specialisation/fellowship-specialisation-add-dialog/fellowship-specialisation-add-dialog.component';
import { ContinousAssesmentEditDialogComponent } from './dialogs/continous-assesment-edit-dialog/continous-assesment-edit-dialog.component';
import { ApprovalDialogComponent } from './dialogs/approval-dialog/approval-dialog.component';
import { TraineeRotationsApproveallDialogComponent } from './dialogs/trainee-rotations-approveall-dialog/trainee-rotations-approveall-dialog.component';
import { MedicalProcedureCaseApprovalDialogComponent } from './dialogs/medical-procedure-case-approval-dialog/medical-procedure-case-approval-dialog.component';
import { ApprovalSuccessSnackbarComponent } from './dialogs/approval-success-snackbar/approval-success-snackbar.component';
import { MedicalProcedureCaseNotApprovalDialogComponent } from './dialogs/medical-procedure-case-not-approval-dialog/medical-procedure-case-not-approval-dialog.component';
import { NotApprovalDialogComponent } from './dialogs/not-approval-dialog/not-approval-dialog.component';
import { AssessmentCaseNotApprovalDialogComponent } from './dialogs/not-approve-assessment/not-approve-assessment.component';
import { TraineeProceduresApproveAllDialogComponent } from './dialogs/trainee-procedure-case-approveall-dialog/trainee-procedure-case-approveall-dialog.component';
import { UserRightDeleteDialogComponent } from './pages/user/user-rights/user-right-delete-dialog/user-right-delete-dialog.component';
import { AssessmentSuccessSnackbarComponent } from './pages/user/continuous-assessment-form-fill/assessment-success-snackbar/assessment-success-snackbar.component';
import { UserRightsAddDialogComponent } from './dialogs/user-rights-add-dialog/user-rights-add-dialog.component';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';

// import { SharedModule } from './shared/shared.module';

//import { AgmCoreModule } from 'angular2-google-maps/core';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		HttpModule,
		HttpClientModule,
		NgbModule.forRoot(),
		BrowserAnimationsModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatDialogModule,
		MatFormFieldModule,
		MatInputModule,
		MatCheckboxModule,
		MatSelectModule,
		MatToolbarModule,
		MatIconModule,
		MatSnackBarModule,
		MatChipsModule,
		MatButtonModule,
		NgxMatTimepickerModule,
		NgxMatDatetimePickerModule,
		MatNativeDateModule,
		MatTooltipModule,

		// SharedModule,

		routing
	],

	exports: [ MatProgressSpinnerModule, MatProgressBarModule ],
	providers: [
		{ provide: MatDialogRef, useValue: {} },
		appRoutingProviders,
		FacultyService,
		FacultyFellowshipSpecialisationService,
		MedicalProcedureService,
		FacultyMedicalProcedureService,
		HospitalService,
		FacultyMedicalProcedureParameterService,
		FacultyMedicalProcedureCaseReviewParameterService,
		ContinuousAssessmentService,
		ContinuingProfessionalDevelopmentService,
		StatsService,
		CanLoadDashboardSection,
		HelpTopicService,
		RotationsService,
		AcademicYearService
	],

	declarations: [
		AppComponent,
		LoginComponent,
		SuccessDialogComponent,
		ErrorDialogComponent,
		PromptDialogComponent,
		EditDialogComponent,
		HospitalEditDialogComponent,
		SuggestedTrainersEditDialogComponent,
		TrainerPasswordEditDailogComponent,
		UsersPasswordResetDialogComponent,
		TraineePasswordResetDialogComponent,
		FellowshipProceduresEditDialogComponent,
		ParameterEditDialogComponent,
		TrainersEditDialogComponent,
		UsersEditDialogComponent,
		TraineesEditDialogComponent,
		FellowshipSpecialisationEditDialogComponent,
		FellowshipCatEditDialogComponent,

		FacultiesAddDialogComponent,
		HospitalAddDialogComponent,
		TrainersAddDialogComponent,
		UserAddDialogComponent,
		TraineeAddDialogComponent,
		EmergencyFellowshipProAddDialogComponent,
		ProcedureHospitalAddDialogComponent,
		ProcedureParameterAddDialogComponent,
		ProcedureReviewParameterAddDialogComponent,

		SuccessSnackbarComponent,
		EmergencyMembershipAddDialogComponent,
		FellowshipSpecialisationAddDialogComponent,
		ContinousAssesmentEditDialogComponent,
		ApprovalDialogComponent,
		NotApprovalDialogComponent,
		TraineeRotationsApproveallDialogComponent,
		TraineeProceduresApproveAllDialogComponent,
		MedicalProcedureCaseApprovalDialogComponent,
		MedicalProcedureCaseNotApprovalDialogComponent,
		AssessmentCaseNotApprovalDialogComponent,
		ApprovalSuccessSnackbarComponent,
		UserRightDeleteDialogComponent,
		AssessmentSuccessSnackbarComponent,
		UserRightsAddDialogComponent
	],

	entryComponents: [
		SuccessDialogComponent,
		ErrorDialogComponent,
		PromptDialogComponent
		// EditDialogComponent
	],

	schemas: [ CUSTOM_ELEMENTS_SCHEMA ],

	bootstrap: [ AppComponent ]
})
export class AppModule {}
